import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import {FormattedMessage, FormattedNumber, IntlProvider} from 'react-intl';
import * as StorageService from "../../services/StorageService.js";
import {
    FIREBASE_SCREEN_NAMES,
    HEADER_SIZE,
    LOCALSTORAGE_ITEMS,
    procStatuses,
    PRODUCT_TYPE
} from "../../util/Constants.js";
import Spinner from '../../components/Spinner.js';
import {EventBus} from "../../util/EventBus";
import {
    addMinutes,
    getAppLocale,
    getProdName,
    getProdOptionsFromCart,
    getProductInfoByPid,
    getProductsOrderFromCart
} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import analyticsLogEvent from "../../services/FirebaseService";
import Moment from "react-moment";
import {DATE_FORMAT} from "../../util/DateUtil";
import ScanQrToContinue from "../../components/ScanQrToContinue";
import {useNavigate} from "react-router";
import AvatarCircleBox from "../../components/AvatarCircleBox";
import {
    confirmGroupProductsOrderHandler,
    getAllAvailableProductsHandler,
    getGroupedOrdersByIdHandler,
    removeGroupProductsOrderHandler,
    sendGroupedOrdersHandler,
    upsertGroupProductsOrderHandler
} from "../../handlers/HandlerProducts";
import {useParams} from "react-router-dom";
import iconCheckMark from "../../assets/img/icon_checkmark_white.svg";
import GroupOrderReviewActionsBar from "../../components/Actionsbar/GroupOrderReviewActionsBar";

function GroupOrderReview() {
    const navigateTo = useNavigate();
    const userEmail = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) : null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const userInfoAnonymous = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO_ANONYMOUS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO_ANONYMOUS)) : null;
    const currency = shopDetails ? shopDetails.currency : null;
    const isBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.barPickup !== "undefined" ? shopDetails.merchantConfig.barPickup : null) : false;
    const timeForBarPickup = shopDetails ? (typeof shopDetails.merchantConfig.timeForBarPickup !== "undefined" ? shopDetails.merchantConfig.timeForBarPickup : null) : false;
    const orderPlace = StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_PLACE) : null;
    const userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const {goid} = useParams();
    const statuses = {
        "CONFIRMED": "CONFIRMED",
        "PENDING": "PENDING",
        "SENT": "SENT"
    }

    const visible = "visible";
    const hidden = "hidden";


    const [state, setState] = useState({
        loading: false,
        allTagsAndProductsStorage: null,
        isSubmitBtnEnabled: true,
        errorMsg: null,
        currentStyle: hidden,
        currentCart: StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.CURRENT_CART)) : null,
        outOfStockProducts: [],
        outOfStockExtras: [],
        genericError: false,
        products: null,
        procStatus: statuses.CONFIRMED,
        status: statuses.PENDING,
        allOrders: null,
    });

    let buttonClicked = false;


    useEffect(() => {
        getPageContent();
    }, [])


    useEffect(() => {
        let delayDebounceFn = null;
        delayDebounceFn = setTimeout(() => {
            checkIfOrderWasChanged();
        }, 5000)
        return () => clearTimeout(delayDebounceFn);
    }, [state]);


    useEffect(() => {
        if (!state.currentCart || (!userTable && isBarPickup === false)) {
            navigateTo(PATH.ALL_PRODUCTS);
        }

        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.ORDER_REVIEW,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.ORDER_REVIEW
        });
    }, []);

    useEffect(() => {
        if (state.currentCart && getProductsOrderFromCart(state.currentCart).length === 0) {
            navigateTo(PATH.ALL_PRODUCTS);
        }
    }, [state.currentCart]);

    useEffect(() => {
        if (state.genericError) {
            EventBus.dispatch("genericErrorMsg");
            setState({
                ...state,
                genericError: false
            });
        }
    }, [state.genericError])


    const bodyForGetGroupOrder = {
        "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
        "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
        "goid": goid,
    }

    const getPageContent = () => {
        getAllAvailableProductsHandler(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME), PRODUCT_TYPE.DINE_IN).then(allProductsResponse => {
            getGroupedOrdersByIdHandler(bodyForGetGroupOrder).then(allGroupOrdersResponse => {
                if (allGroupOrdersResponse.data.error === null && allGroupOrdersResponse.data.groupedOrder.orders.length !== 0) {
                    const currentUserOrder = allGroupOrdersResponse.data.groupedOrder.orders.find(order => order.user === userEmail)
                    setState({
                        ...state,
                        allOrders: allGroupOrdersResponse.data.groupedOrder.orders,
                        name: allGroupOrdersResponse.data.groupedOrder.name,
                        procStatus: allGroupOrdersResponse.data.groupedOrder.procStatus,
                        status: currentUserOrder.confirmed ? statuses.CONFIRMED : statuses.PENDING,
                        allTagsAndProductsStorage: allProductsResponse
                    })
                } else {
                    navigateTo(PATH.ALL_PRODUCTS);
                }
            })
        })


    }


    const checkIfOrderWasChanged = () => {
        getGroupedOrdersByIdHandler(bodyForGetGroupOrder).then(allGroupOrdersResponse => {
            if (allGroupOrdersResponse.data.error === null && allGroupOrdersResponse.data.groupedOrder.orders.length !== 0) {
                if (allGroupOrdersResponse.data.groupedOrder.procStatus === procStatuses.SENT) {
                    StorageService.setItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID, goid);
                    navigateTo(PATH.GROUP_ORDER_SUMMARY + "/" + goid);
                } else {
                    const currentUserOrder = allGroupOrdersResponse.data.groupedOrder.orders.find(order => order.user === userEmail);
                    setState({
                        ...state,
                        allOrders: allGroupOrdersResponse.data.groupedOrder.orders,
                        name: allGroupOrdersResponse.data.groupedOrder.name,
                        procStatus: allGroupOrdersResponse.data.groupedOrder.procStatus,
                        status: currentUserOrder.confirmed ? statuses.CONFIRMED : statuses.PENDING,
                        errorMsg: null
                    })
                }

            } else {
                navigateTo(PATH.ALL_PRODUCTS);
            }
        })
    }

    const closeModal = () => {
        setState({
            ...state,
            currentStyle: hidden
        })
    }


    const sendGroupOrder = async () => {
        setState({
            ...state,
            loading: true,
            isSubmitBtnEnabled: false
        })
        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "goid": goid,
            "name": userInfo && userInfo.firstName && userInfo.lastName ? userInfo.firstName + " " + userInfo.lastName : userInfoAnonymous.user.firstName,
            "products": getProductsOrderFromCart(state.currentCart).flatMap(product => {
                return product.choices.map(choice => {
                    return {
                        "pid": product.pid,
                        "quantity": choice.quantity,
                        "msg": choice.msg ? choice.msg : null,
                        "option": choice.option ? choice.option : null,
                        "extras": choice.extras.length > 0 ? choice.extras.map(e => e.pid) : null
                    }
                });
            }),
        }

        const data = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "goid": goid,
        }
        const upsertResponse = await upsertGroupProductsOrderHandler(body);
        const sendGroupResponse = await sendGroupedOrdersHandler(data);
        if (upsertResponse.data.error === null && sendGroupResponse.data.error === null) {
            StorageService.setItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID, goid);
            navigateTo(PATH.GROUP_ORDER_SUMMARY + "/" + goid);
        } else {
            setState({
                ...state,
                errorMsg: <FormattedMessage id="CouldNotSentOrder"/>
            })
        }
    }


    const getEstimatedPickupTime = () => {
        return <Moment
            format={DATE_FORMAT.HOUR_MINUTES}
            date={addMinutes(new Date(), timeForBarPickup)}
        />
    }

    const openModal = () => {
        setState({
            ...state,
            currentStyle: visible
        })
    }
    const onCloseGroupOrderBtnClick = () => {

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "goid": goid
        }
        removeGroupProductsOrderHandler(body).then(r => {
            StorageService.removeItem(LOCALSTORAGE_ITEMS.GROUP_ORDER_ID);
        })
        navigateTo(PATH.ALL_PRODUCTS);
    }

    const onChangeOrder = async () => {

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "goid": goid,
            "confirmed": false,
            "name": userInfo && userInfo.firstName && userInfo.lastName ? userInfo.firstName + " " + userInfo.lastName : userInfoAnonymous.user.firstName,
            "products": getProductsOrderFromCart(state.currentCart).flatMap(product => {
                return product.choices.map(choice => {
                    return {
                        "pid": product.pid,
                        "quantity": choice.quantity,
                        "msg": choice.msg ? choice.msg : null,
                        "option": choice.option ? choice.option : null,
                        "extras": choice.extras.length > 0 ? choice.extras.map(e => e.pid) : null
                    }
                });
            }),
        }
        await upsertGroupProductsOrderHandler(body);
        navigateTo(PATH.ALL_PRODUCTS);
        setState({
            ...state,
            orderStatus: statuses.PENDING
        })
    }

    const onConfirmOrder = () => {

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "goid": goid
        }

        confirmGroupProductsOrderHandler(body).then(r => {
            setState({
                ...state,
                status: statuses.CONFIRMED,
                allOrders: state.allOrders.map(order => order.user === userEmail ?
                    {...order, confirmed: true}
                    : order
                ),
            })
        })
    }


    if ((state.currentCart && isBarPickup === true) || (userTable && state.currentCart && !isBarPickup)) {
        return (
            <>
                <Header
                    headerSize={HEADER_SIZE.SMALL}
                    headerTitle={<FormattedMessage id="GroupOrder"/>}
                    hasBackBtn={true}
                    hasModal={true}
                    hasCloseGroupOrderBtn={state.procStatus === procStatuses.OPEN}
                    onCloseGroupOrderBtnClick={() => openModal()}
                />

                {/*START PAGE-CONTENT*/}
                <main className="page-content">
                    <div className={state.currentStyle + " modal-overlay "} onClick={(e) => closeModal()}></div>
                    <div data-qa="modal" className="modal">
                        <div className="row">
                            <div className="modal-title"><FormattedMessage id="YourOrderWillNotBeSent"/></div>
                        </div>

                        <div className="row">
                            <p className="modal-text"><FormattedMessage id="AreYouSureYouWantToLeaveGroup"/></p>
                        </div>
                        <br/>
                        <div className="row buttons-row">
                            <a className="link neutral btn-md" id="cancel" onClick={() => closeModal()} data-qa="cancel-btn"><FormattedMessage id="Cancel"/></a>
                                <a className="link dark btn-md" id="CARD" onClick={() => onCloseGroupOrderBtnClick()} data-qa="close-group-btn"><FormattedMessage id="Leave"/></a>
                        </div>




                    </div>
                    <div className="order-details-top-msg">


                        <div className="row"><FormattedMessage id="YourOrderWillBeDelivered"/>
                            <span className="order-details-table">&nbsp;{userTable}</span>
                        </div>
                        <div className="row">
                            {state.allOrders && state?.allOrders.map(order => (
                                <>
                                    <AvatarCircleBox
                                        innerText={order.name ? order.name[0].toUpperCase() : order.user[0].toUpperCase()}
                                        status={order.confirmed ? "success" : "pending"}
                                        size={"big"}/>
                                    &nbsp;  &nbsp;
                                </>

                            ))}

                        </div>

                    </div>

                    {<div className="row justify-content-end">
                        {state.status === statuses.PENDING && <button onClick={() => onConfirmOrder()}
                                                                      className="btn btn-xs btn-default change-order-btn">
                            <FormattedMessage
                                id="Confirm"/></button>}
                        <button onClick={() => onChangeOrder()} className="btn btn-xs btn-outlined change-order-btn">
                            <FormattedMessage
                                id="ChangeOrder"/></button>
                    </div>}
                    {state.allOrders && state?.allOrders.map(order => (
                        <section className="order-details-card">
                            <div className="card-content">
                                <div className="name-and-status row">
                                    <div className="col">
                                        <AvatarCircleBox
                                            innerText={order.name ? order.name[0].toUpperCase() : order.user[0].toUpperCase()}
                                            size={"small"}
                                            status={order.confirmed ? "success" : "pending"}
                                        />
                                        &nbsp;&nbsp;
                                        <span className="name">{order.name ? order.name : order.user}</span>
                                    </div>
                                    <div className="col ml-auto">

                                        {order.confirmed ?
                                            <>
                                                <FormattedMessage id="Confirmed"/>
                                                &nbsp; &nbsp;
                                                <span className="status success small">
                                                                            <img className="icon-checkmark"
                                                                                 src={iconCheckMark} alt=""/>
                                                                        </span>
                                            </>
                                            :
                                            <>
                                                <FormattedMessage id="PendingConfirmation"/> &nbsp;&nbsp;
                                                <span className="status pending small"> <div className="spinner"
                                                                                             data-qa="spinner"><Spinner/></div></span>
                                            </>
                                        }

                                    </div>
                                </div>


                                {state.allTagsAndProductsStorage && order.products.map((product, index) => (

                                    <div key={index + product}
                                         className="product"
                                         data-qa="product">
                                        <div className="row">

                                                        <span onClick={(e) => e.stopPropagation()}
                                                              className="qty-element">{product.quantity}x</span>
                                            &nbsp;
                                            <span
                                                className={state.outOfStockProducts?.includes(product.pid) ? "prod-name danger ml-0" : "prod-name ml-0"}>
                                                            {getProdName(getProductInfoByPid(state.allTagsAndProductsStorage, product.pid))}
                                                        </span>
                                            <span className="prod-price">&nbsp;
                                                <IntlProvider
                                                    locale={getAppLocale()}>
                                                                 <FormattedNumber
                                                                     value={
                                                                         getProductInfoByPid(state.allTagsAndProductsStorage, product.pid).price / 100.0}
                                                                     style="currency"
                                                                     minimumFractionDigits={2}
                                                                     maximumFractionDigits={2}
                                                                     currency={currency}/>
                                                                 </IntlProvider>
                                                        </span>
                                        </div>
                                        {(product.option || product.msg) && <div className="choices row">

                                            {product.option ?
                                                <span>
                                                                    {getProdOptionsFromCart(product)}
                                                    &nbsp;</span>
                                                : null
                                            }
                                            {product.msg ?
                                                <span>({product.msg})&nbsp;</span>
                                                : null
                                            }
                                        </div>}
                                        {product.extras && <div className="choices row">
                                            <>
                                                {product.extras}
                                            </>

                                        </div>}
                                    </div>


                                ))
                                }


                            </div>
                        </section>


                    ))}


                    {state.errorMsg != null ? <div className="error-div">&#9888;&nbsp;{state.errorMsg}</div> : null}
                </main>
                {/*END PAGE-CONTENT*/}


                <GroupOrderReviewActionsBar

                    isVisible={true}
                    buttonName={<FormattedMessage id="SendGroupOrder"/>}
                    dataQAIdentifier={"order-review-submit-btn"}
                    btnClassName={state.isSubmitBtnEnabled ? "btn btn-default btn-xl" : "btn btn-default btn-xl btn-disabled"}
                    buttonAction={() => {
                        state.isSubmitBtnEnabled ? sendGroupOrder() : void (0);
                    }}


                />

                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }
            </>
        )
    } else {
        return (
            <ScanQrToContinue/>
        )
    }

}

export default GroupOrderReview;
